(function ($) {
    RVwys.plugin['sectionPropreties'] = true;
    RVwys.getRowBG = '';
    RVwys.getrowProperties = '';
    RVwys.getBlockProperties = '';

    RVwys.setCurrentParallaxCustomBlock = function (obj) {
        //alert(obj.html())
        var parallax = obj.attr('data-uk-parallax');
        var classactive =
            obj.attr('data-parallax-classactive') == undefined
                ? 'rv-animation-None'
                : obj.attr('data-parallax-classactive');

        parent.$(`.animateParallax`).removeClass('ani_current');
        parent
            .$(`.${classactive}`)
            .closest('.animateParallax')
            .addClass('ani_current');

        parent.$('#parallaxBlockCustomtxt').val(parallax);
    };

    RVwys.setCurrentParallaxCustomSection = function (obj) {
        parent.RVwys.getRowBG = RVwys.getParentByClass(
            $(obj),
            'rvsb_design_block'
        );

        if (parent.RVwys.getRowBG.closest('#selected_footer').get(0)) {
            parent.RVwys.getRowBG = parent.RVwys.getRowBG.find(
                '#footerTemplate'
            );
        }
        //alert(parent.RVwys.getRowBG.parent().attr('data-uk-parallax'))
        //alert(parent.$('#parallaxSectionCustomtxt').get(0))
        parent
            .$('#parallaxSectionCustomtxt')
            .val(parent.RVwys.getRowBG.parent().attr('data-uk-parallax'));
    };
    RVwys.setCurrentRowBG = function (obj) {
        parent.RVwys.getRowBG = RVwys.getParentByClass(
            $(obj),
            'rvsb_design_block'
        );
        //bgColor = RVwys.rgb2hex(parent.RVwys.getRowBG.css('background-color'));
        var bgColor = parent.RVwys.getRowBG.css('background-color');
        var gdColor =
            parent.RVwys.getRowBG.css('background-image') == 'none'
                ? ''
                : parent.RVwys.getRowBG.css('background-image');
        parent.$('#set-rowProperties').spectrum('set', bgColor);

        RVwys.SetCurrentGradient(gdColor, true);

        var isFull = parent.RVwys.getRowBG.parent().hasClass('rv-block-full');
        parent.$('#rowfull').prop('checked', isFull);
    };

    RVwys.setCurrentBlockBG = function (obj) {
        var bgColor = parent.RVwys.getBlockBG.css('background-color');
        var gdColor =
            parent.RVwys.getBlockBG.css('background-image') == 'none'
                ? ''
                : parent.RVwys.getBlockBG.css('background-image');

        parent.$('#set-blockProperties').spectrum('set', bgColor);
        RVwys.SetCurrentGradient(gdColor, false);
    };

    RVwys.setCurrentBlockBGIMAGE = function (BlockActive) {
        var isbgAttch =
            BlockActive.css('background-attachment') == 'fixed' ? true : false;
        var bgimage = BlockActive.css('background-image');
        var bgPos = BlockActive.get(0).style.backgroundPositionX;
        var keyPosX = {
            left: 'left',
            center: 'center',
            right: 'right',
            '0%': 'left',
            '50%': 'center',
            '100%': 'right',
            inherit: 'inherit',
            initial: 'initial',
            unset: 'unset',
            null: 'left',
            undefined: 'left',
            none: 'left',
            '': 'left',
        };

        parent.$('#bgFixed-block').prop('checked', isbgAttch);

        if (bgimage != 'none' || bgimage == '') {
            // bgimage = bgimage.replace(/(url\(|\)|")/img,'');
            bgimage = bgimage.replace(/\/[S|M|L]\//, '/');
            var aBG = bgimage.split('/');

            aBG.splice(aBG.length - 1, 0, 'wpThumbnails');
            bgimage = aBG.join('/');

            if (bgimage.match(/url/)) {
                parent
                    .$('.block-bg')
                    .css('background', bgimage + ' no-repeat 50% / contain');
            } else {
                parent.$('.block-bg').css('background', '');
            }
        } else {
            parent.$('.block-bg').css('background', '');
        }

        //parent.$(".positon-block option").attr('selected', '');

        parent.$('.positon-block').val(keyPosX[bgPos]);
        parent.$('.gdColorBlock').spectrum('set', 'transparent');
        parent
            .$('.gdColorBlock')
            .next()
            .find('.sp-preview-inner')
            .addClass('sp-clear-display');
    };
    RVwys.setCurrentBGIMAGE = function (obj) {
        parent.RVwys.getRowBG = RVwys.getParentByClass(
            $(obj),
            'rvsb_design_block'
        );
        //bgColor = RVwys.rgb2hex(parent.RVwys.getRowBG.css('background-color'));
        parent.$('#bgFixed').prop('checked', isbgAttch);
        var isbgAttch =
            parent.RVwys.getRowBG.parent().css('background-attachment') ==
            'fixed'
                ? true
                : false;
        var bgimage = parent.RVwys.getRowBG.parent().css('background-image');
        var bgPos = parent.RVwys.getRowBG.parent().get(0).style
            .backgroundPositionX;
        var keyPosX = {
            left: 'left',
            center: 'center',
            right: 'right',
            '0%': 'left',
            '50%': 'center',
            '100%': 'right',
            inherit: 'inherit',
            initial: 'initial',
            unset: 'unset',
            null: 'left',
            undefined: 'left',
            none: 'left',
            '': 'left',
        };

        if (bgimage != 'none' || bgimage == '') {
            //bgimage = bgimage.replace(/(url\(|\)|")/img,'');
            bgimage = bgimage.replace(/\/[S|M|L]\//, '/');

            var aBG = bgimage.split('/');

            aBG.splice(aBG.length - 1, 0, 'wpThumbnails');
            bgimage = aBG.join('/');
            parent
                .$('.section-bg')
                .css('background', bgimage + ' no-repeat 50% / contain');
        } else {
            parent.$('.section-bg').css('background', '');
        }

        parent.$('.positon-section').val(keyPosX[bgPos]);
        parent.$('.gdColorSection').spectrum('set', 'transparent');
        parent
            .$('.gdColorSection')
            .next()
            .find('.sp-preview-inner')
            .addClass('sp-clear-display');
    };

    RVwys.setRowBG = function (color) {
        var elm =
            RVwys.getRowBG ||
            RVwys.getParentByClass(
                $(RVwys.targetAnimatObj),
                'rvsb_design_block'
            );
        console.log('bg' + color);
        if (parent.rowParallaxSlide) {
            elm.addClass('uk-overlay-panel');
        }

        elm.get(0).style.background = '';
        elm.get(0).style.backgroundColor = color ? color : '';
        //	(color) ? elm.css({'background-color':color})
        //			: elm.css({'background-color':''});

        $('.gdColorSection').spectrum('set', 'transparent');
        $('.gdColorSection')
            .next()
            .find('.sp-preview-inner')
            .addClass('sp-clear-display');
    };

    //blockProperties
    RVwys.getBlockBG = '';
    RVwys.setBlockBG = function (color) {
        var elm = RVwys.getBlockBG || RVwys.currentEditor;
        /* 		console.log(RVwys.getBlockBG);
		console.log(RVwys.currentEditor);
		console.log	('RVwys.currentEditor-->'+elm.tagName); */
        //	alert(color)
        //	(color) ? elm.css({'background-color':color})
        //			: elm.css({'background-color':''});
        elm.get(0).style.backgroundImage = '';
        elm.get(0).style.backgroundColor = color ? color : '';
    };

    // Animation
    RVwys.targetAnimatObj = true;
    RVwys.effectClass =
        'uk-animation-fade uk-animation-scale-up uk-animation-scale-down uk-animation-slide-top uk-animation-slide-bottom uk-animation-slide-left uk-animation-slide-right';

    RVwys.setAnimation = function () {
        var acls = $('#animation-scrollSpy').find('.ani_current').attr('set');

        if (acls == 'none') {
            $(RVwys.targetAnimatObj).removeAttr('rv-data-uk-scrollspy');
            var txt = parent.$(".div[set='1000']").attr('txt');

            parent.$('.animationTime dt a span').text(txt);
            $('.animationTime dt a span').text(txt);
            $('#setAnimationRepeat').prop('checked', false);
        } else {
            var ttime = $('.animationTime dt a span').text();
            var adelay = $('.animationTime')
                .find("a[txt='" + ttime + "']")
                .attr('set');
            var arepeat = $('#setAnimationRepeat').is(':checked');
            var setA =
                "{'cls':'" +
                acls +
                "','delay':'" +
                adelay +
                "','repeat':'" +
                arepeat +
                "'}";
            $(RVwys.targetAnimatObj).attr('rv-data-uk-scrollspy', setA);
        }
    };

    RVwys.setDefaultAnimation = function (obj) {
        //obj;//RVwys.currentiFrame;
        var val = obj.attr('rv-data-uk-scrollspy');
        parent.$('.animateBlock').removeClass('ani_current');
        if (val) {
            val = val.replace(/\'/gim, '"');
            var oAnime = window.JSON.parse(val);
            var txt = parent
                .$(".setAnimationTime[set='" + oAnime.delay + "']")
                .attr('txt');
            parent
                .$('#setAnimationRepeat')
                .prop('checked', JSON.parse(oAnime.repeat)); //THIS convert true fals JSON.parse(oAnime.repeat)
            parent
                .$('#animation-scrollSpy')
                .find("div[set='" + oAnime.cls + "']")
                .addClass('ani_current');
            parent.$('.animationTime dt a span').text(txt);
        } else {
            var txt = parent.$(".setAnimationTime[set='1000']").attr('txt');
            parent.$('#setAnimationRepeat').prop('checked', false);
            parent
                .$('#animation-scrollSpy')
                .find("div[set='none']")
                .addClass('ani_current');
            parent
                .$('.animationTime ')
                .find('.setAnimationTime[set=1000]')
                .addClass('ani_current');
            parent.$('.animationTime dt a span').text(txt);
            //1000
        }
    };

    $(document).bind('editorReady', function () {
        $('#parallaxSectionCustom').click(function (e) {
            var fb = $('#frameBody').get(0).contentWindow;
            var sectionActive = $('.mgActive').get(0)
                ? $('.mgActive')
                : fb.$('.mgActive');
            //alert(sectionActive.parent().attr('data-uk-parallax'));
            //alert($(this).val())
            var txt = $('#parallaxSectionCustomtxt');
            sectionActive.parent().attr('data-uk-parallax', txt.get(0).value);

            var d = new Date();
            var n = d.getTime();
            var bgurl = sectionActive
                .parent()
                .css('background-image')
                .replace('url(', '')
                .replace(')', '')
                .replace(/["|']/gim, '')
                .replace(/\?n=\w*/gim, '');
            bgurl = bgurl + '?n=' + n;
            sectionActive.parent().css({
                //'background-size':'',
                //'background-repeat':'no-repeat',
                'background-image': 'url(' + bgurl + ')',
                'background-position': '',
            });

            var mg = RVwys.getParentByClass(sectionActive, 'mg');
            var mgClone = mg.clone();
            mg.after(mgClone);
            mg.remove();
            mgClone
                .find('.RVWYSIWYGAREA')
                .each(function () {
                    id = $(this).attr('id') + n + $(this).index();
                    $(this).attr('id', id);
                    testEditor = fb.RVwys.EditorByClass('#' + id, true);
                })
                .eq(0)
                .focus();

            //RVwys.startUIkit();

            a = JSON.parse(eval(txt.get(0).value));
            console.log(' uikit parallax');
            console.log(a);
            setTimeout(function () {
                fb.UIkit.parallax(sectionActive.parent(), a);
            }, 200);
        });
        $('#bgFixed').click(function () {
            if (parent.rowParallaxSlide) {
                //			.children('div')
                var sectionActive = $('#frameBody')
                    .get(0)
                    .contentWindow.$('li[data-slideshow-slide].uk-active');
                var bgAttch = $(this).is(':checked') ? 'fixed' : '';

                sectionActive.children('div').css({
                    'background-attachment': bgAttch,
                });
                sectionActive.children('img').css({
                    'background-attachment': bgAttch,
                });
            } else {
                var sectionActive = $('.mgActive').get(0)
                    ? $('.mgActive')
                    : $('#frameBody').get(0).contentWindow.$('.mgActive');

                var bgAttch = $(this).is(':checked') ? 'fixed' : '';
                //alert(sectionActive.parent().get(0))
                sectionActive.parent().css({
                    'background-attachment': bgAttch,
                });
            }
        });

        $('#bgFixed-block').click(function () {
            var bgAttch = $(this).is(':checked') ? 'fixed' : '';

            RVwys.getBlockBG.css({
                'background-attachment': bgAttch,
            });
        });

        $('.setting-widget')
            .click(function () {
                //parent.$('.wys-desktopmode').trigger( "click");
                frameBody.contentWindow
                    .$('.mgActive')
                    .find('.handledProp')
                    .trigger('click');
            })
            .keypress(function (e) {
                if (e.keyCode == $.ui.keyCode.ENTER) {
                    return false;
                }
            });

        console.log($('#rowfull'));

        $('#rowfull').click(function () {
            var rowfull = parent.RVwys.getrowProperties;

            if (rowfull.is('#footerTemplate')) {
                rowfull = rowfull.closest('.mg').children();
            }

            if ($(this).is(':checked')) {
                rowfull.addClass('rv-block-full');
            } else {
                rowfull.removeClass('rv-block-full');
            }
        });

        $('#set-rowProperties').spectrum({
            showAlpha: true,
            showInput: true,
            allowEmpty: true,
            preferredFormat: 'rgb',
            beforeShow: function () {
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    'background-color': 'red',
                    opacity: '0.0',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $('body').width(),
                    height: $('body').height(),
                });
                parent.$('body').prepend(overlaypanel);
                parent.$(document).bind('click.spectrum', function () {
                    //alert(tinycolor.getOriginalInput)
                    $('#set-rowProperties').spectrum('revert');
                    //clickout();
                });
            },

            move: function (color) {
                RVwys.setRowBG(color);
            },

            hide: function (color) {
                RVwys.setRowBG(color);
                parent.$('.overlaypanel').remove();
                parent.$(document).unbind('click.spectrum');
            },
        });

        //	 BlockProperties

        $('.setEffect').remove();
        //console.log(parent.rvParallax)

        $('.blockbackground-tabs').tabs();

        $.each(parent.rvParallax, function (k, v) {
            var setEffect = $(
                `<a id="setEffect" title="${k}" class="setEffect rv-animation-${k}" href="javascript:void(0);" data="${v}" classActive ="rv-animation-${k}"></a>`
            );

            setEffect.click(function () {
                // alert($(this).attr('data'))
                // parent.RVwys.getBlockBG.attr('data-uk-parallax',$(this).attr('data'));

                $('.animateParallax').removeClass('ani_current');
                $(this).closest('.animateParallax').addClass('ani_current');
                var animateParallax = $(this).attr('data');

                $('#parallaxBlockCustomtxt')
                    .attr(
                        'data-parallax-classactive',
                        $(this).attr('classactive')
                    )
                    .val(animateParallax);
                $('#parallaxBlockCustom').trigger('click');
            });

            $('.effectParallax').append(
                $(
                    `<div class="uk-panel uk-panel-box animateParallax" data="${v}"></div>`
                ).append(setEffect)
            );
        });
        $('#parallaxBlockCustom').click(function (e) {
            var txt = $('#parallaxBlockCustomtxt').get(0).value;
            var classactive = $('#parallaxBlockCustomtxt').attr(
                'data-parallax-classactive'
            );
            var fb = $('#frameBody').get(0).contentWindow;
            // Replace ' to " fetch parallax not work
            // txt = txt.replace(/\'/g, '"');
            txt = txt.replace(/\"/g, "'");

            if (txt == '' && parent.RVwys.getBlockBG.css('opacity') == 0) {
                parent.RVwys.getBlockBG.css('opacity', '');
            }

            parent.RVwys.getBlockBG.attr(
                'data-parallax-classactive',
                classactive
            );
            parent.RVwys.getBlockBG.attr('data-uk-parallax', txt);

            var d = new Date();
            var n = d.getTime();

            var mg = parent.RVwys.getBlockBG;
            var mgClone = mg.clone();
            mg.after(mgClone);
            mg.remove();
            if (mgClone.attr('id')) {
                var id = mgClone.attr('id') + n + $(this).index();
                mgClone.attr('id', id);
                testEditor = fb.RVwys.EditorByClass('#' + id, true);
                mgClone.focus();
            }

            //RVwys.startUIkit();
            var a = UIkit.Utils.options(txt);
            parent.RVwys.getBlockBG = mgClone;
            setTimeout(function () {
                fb.UIkit.parallax(parent.RVwys.getBlockBG, a);
            }, 200);
        });

        $('#set-blockProperties').spectrum({
            showAlpha: true,
            showInput: true,
            allowEmpty: true,
            preferredFormat: 'rgb',
            beforeShow: function () {
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    'background-color': 'red',
                    opacity: '0.0',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $('body').width(),
                    height: $('body').height(),
                });
                parent.$('body').prepend(overlaypanel);
                parent.$(document).bind('click.spectrum', function () {
                    //alert(tinycolor.getOriginalInput)
                    $('#set-blockProperties').spectrum('revert');
                    //clickout();
                });
            },
            move: function (color) {
                RVwys.setBlockBG(color);
            },

            hide: function (color) {
                RVwys.setBlockBG(color);
                parent.$('.overlaypanel').remove();
                parent.$(document).unbind('click.spectrum');
            },
        });

        // Animation

        $('.setAnimation').click(function (e) {
            $('#frameBody')
                .contents()
                .find('.RVWYSIWYGAREA')
                .removeClass(RVwys.effectClass);
            var othis = $(this);
            var ttime = $('.animationTime dt a span').text();
            var adelay = $('.animationTime')
                .find("a[txt='" + ttime + "']")
                .attr('set');
            $('.animateBlock').removeClass('ani_current');
            othis.addClass('ani_current');
            if (RVwys.targetAnimatObj) {
                $(RVwys.targetAnimatObj)
                    .removeClass(RVwys.effectClass)
                    .each(function () {
                        $(RVwys.targetAnimatObj).addClass(othis.attr('set'));
                        setTimeout(function () {
                            $(RVwys.targetAnimatObj).removeClass(
                                RVwys.effectClass
                            );
                        }, 2000);
                    });
            }
            RVwys.setAnimation();
        });

        $('.setAnimationTime').click(function (e) {
            // var rowfull = RVwys.getParentByClass($(RVwys.currentiFrame),'rvsb_design_block');
            $('.animationTime dt a span').text($(this).attr('txt'));
            $('.animationTime dd ul').hide();
            RVwys.setAnimation();
        });
        $('#setAnimationRepeat').click(function () {
            RVwys.setAnimation();
        });

        $('.spGradient .rv-theme').click(function () {
            //use background
            var KeyClass = $(this)
                .attr('class')
                .match(/rv-section-(\w*)/)[0];
            //		   CSSJSON.toJSON();

            var cssJson = parent.JsonStyleSection;
            var cssStyle =
                cssJson['children']['.' + KeyClass]['attributes']['background'];

            var elm =
                RVwys.getRowBG ||
                RVwys.getParentByClass(
                    $(RVwys.targetAnimatObj),
                    'rvsb_design_block'
                );
            var isSection = true;
            if ($(this).closest('.spGradient').hasClass('spGradient-Block')) {
                elm = RVwys.getBlockBG;
                isSection = false;
                $('#set-blockProperties').spectrum('set', 'transparent');
                $('#set-blockProperties')
                    .next()
                    .find('.sp-preview-inner')
                    .addClass('sp-clear-display');
            } else {
                $('#set-rowProperties').spectrum('set', 'transparent');
                $('#set-rowProperties')
                    .next()
                    .find('.sp-preview-inner')
                    .addClass('sp-clear-display');
            }

            cssStyle = cssStyle ? cssStyle : '';
            elm.get(0).style.background = cssStyle;

            RVwys.SetCurrentGradient(cssStyle, isSection);
        });

        $('.section-gradient span').click(function () {
            var KeyClass = $(this).attr('class');
            var cssJson = parent.JsonStyleSection;
            var CssClass =
                cssJson['children']['.section-gradient .' + KeyClass][
                    'attributes'
                ];
            var cssStyleBG =
                cssJson['children']['.section-gradient .' + KeyClass][
                    'attributes'
                ]['background'];
            var cssStyleFilter =
                cssJson['children']['.section-gradient .' + KeyClass][
                    'attributes'
                ]['background'];

            var elm =
                RVwys.getRowBG ||
                RVwys.getParentByClass(
                    $(RVwys.targetAnimatObj),
                    'rvsb_design_block'
                );

            if (parent.rowParallaxSlide) {
                elm.addClass('uk-overlay-panel');
            }

            var isSection = true;
            if (
                $(this).closest('.section-gradient').hasClass('block-gradient')
            ) {
                elm = RVwys.getBlockBG;
                isSection = false;
                $('#set-blockProperties').spectrum('set', 'transparent');
                $('#set-blockProperties')
                    .next()
                    .find('.sp-preview-inner')
                    .addClass('sp-clear-display');

                parent.$('.block-bg').css('background', '');
            } else {
                $('#set-rowProperties').spectrum('set', 'transparent');
                $('#set-rowProperties')
                    .next()
                    .find('.sp-preview-inner')
                    .addClass('sp-clear-display');
            }

            elm.get(0).style.background = cssStyleBG[0];
            elm.get(0).style.filter = cssStyleFilter;

            RVwys.SetCurrentGradient(cssStyleBG[0], isSection);

            // console.log(elm.get(0).style);
        });

        $('.positon-section').change(function () {
            var sectionActive = $('.mgActive').get(0)
                ? $('.mgActive')
                : $('#frameBody').get(0).contentWindow.$('.mgActive');

            var position = $(this).find(':selected').attr('value');

            sectionActive
                .parent()
                .css({ 'background-position': position + ' top' });
        });

        $('.positon-block').change(function () {
            var position = $(this).find(':selected').attr('value');
            RVwys.getBlockBG.css({ 'background-position': position + ' top' });
        });

        $('.range-slider-active').slider({
            slide: function (event, ui) {
                var isInputData = $(this).parent().next().find('input');
                isInputData.val(ui.value).keyup();
            },
        });

        $('.range-slider-lenght').slider('option', { min: -50, max: 50 });

        $('.range-slider-radius').slider('option', { min: 0, max: 50 });

        $('.range-slider-margin').slider('option', { min: -100, max: 100 });

        $('.range-slider-Box').slider('option', { min: 0, max: 1000 });

        $('.range-slider-BoxPadding').slider('option', { min: 0, max: 100 });

        $('.range-slider-Block').slider('option', { min: 0, max: 100 });

        $('.Input-slide-section,.Input-slide-block').bind(
            'keyup mouseup',
            function () {
                var isValue = $(this).val();
                var isRang = $(this).parent().prev().find('.ui-slider');
                isRang.slider('value', isValue);

                var sectionActive = $('.mgActive').get(0)
                    ? $('.mgActive').parent()
                    : $('#frameBody')
                          .get(0)
                          .contentWindow.$('.mgActive')
                          .parent();

                if ($(this).hasClass('Input-slide-block')) {
                    sectionActive = RVwys.getBlockBG;
                    RVwys.setBlockShadow(sectionActive);
                } else {
                    RVwys.setSectionShadow(sectionActive);
                }
            }
        );

        $('.Input-section-margin,.Input-block-margin').bind(
            'keyup mouseup',
            function () {
                var isRang = $(this)
                    .parent()
                    .prev()
                    .find('.range-slider-margin');
                var isValue = $(this).val();

                isRang.slider('value', isValue);

                var Activemargin = $(this).attr('id');
                var mgValue =
                    $(this).val() == '' ? 'auto' : $(this).val() + '%';

                var sectionActive = $('.mgActive').get(0)
                    ? $('.mgActive').parent()
                    : $('#frameBody')
                          .get(0)
                          .contentWindow.$('.mgActive')
                          .parent();

                if ($(this).hasClass('Input-block-margin')) {
                    sectionActive = RVwys.getBlockBG.parent();
                    switch (Activemargin) {
                        case 'set-mgLeftBlock':
                            sectionActive.css('margin-left', mgValue);
                            break;
                        case 'set-mgRightBlock':
                            sectionActive.css('margin-right', mgValue);
                            break;
                        case 'set-mgTopBlock':
                            sectionActive.css('margin-top', mgValue);
                            break;
                        case 'set-mgBottomBlock':
                            sectionActive.css('margin-bottom', mgValue);
                            break;
                    }
                } else {
                    switch (Activemargin) {
                        case 'set-mgLeftSection':
                            sectionActive.css('margin-left', mgValue);
                            break;
                        case 'set-mgRightSection':
                            sectionActive.css('margin-right', mgValue);
                            break;
                        case 'set-mgTopSection':
                            sectionActive.css('margin-top', mgValue);
                            break;
                        case 'set-mgBottomSection':
                            sectionActive.css('margin-bottom', mgValue);
                            break;
                    }
                }
            }
        );

        $('.Input-slide-BoxRadius').bind('keyup mouseup', function () {
            var sectionActive = $('.mgActive').get(0)
                ? $('.mgActive')
                : $('#frameBody').get(0).contentWindow.$('.mgActive');

            if ($(this).hasClass('Input-slide-BoxRadiusAll-Block')) {
                sectionActive = RVwys.getBlockBG;
            }

            var isRang = $(this).parent().prev().find('.ui-slider');
            var isValue = $(this).val();

            isRang.slider('value', isValue);

            var Activemargin = $(this).attr('id');

            switch (Activemargin) {
                // Section
                case 'set-rdLeftSection':
                    var topLeft = $('#set-rdLeftSection').val();
                    sectionActive.css('border-top-left-radius', topLeft + 'px');
                    sectionActive
                        .parent()
                        .css('border-top-left-radius', topLeft + 'px');
                    break;

                case 'set-rdRightSection':
                    var topRight = $('#set-rdRightSection').val();
                    sectionActive.css(
                        'border-top-right-radius',
                        topRight + 'px'
                    );
                    sectionActive
                        .parent()
                        .css('border-top-right-radius', topRight + 'px');
                    break;

                case 'set-rdBTLeftSection':
                    var BTLeft = $('#set-rdBTLeftSection').val();
                    sectionActive.css(
                        'border-bottom-left-radius',
                        BTLeft + 'px'
                    );
                    sectionActive
                        .parent()
                        .css('border-bottom-left-radius', BTLeft + 'px');
                    break;

                case 'set-rdBTRightSection':
                    var BTRight = $('#set-rdBTRightSection').val();
                    sectionActive.css(
                        'border-bottom-right-radius',
                        BTRight + 'px'
                    );
                    sectionActive
                        .parent()
                        .css('border-bottom-right-radius', BTRight + 'px');
                    break;

                case 'set-allRDSection':
                    var BTAll = $('#set-allRDSection').val();
                    $('.range-slider-all').slider('value', BTAll);
                    $('.Input-slide-BoxRadiusAll').val(BTAll).keyup();
                    break;

                // Block
                case 'set-rdLeftBlock':
                    var topLeftBlock = $('#set-rdLeftBlock').val();
                    sectionActive.css(
                        'border-top-left-radius',
                        topLeftBlock + 'px'
                    );
                    break;

                case 'set-rdRightBlock':
                    var topRightBlock = $('#set-rdRightBlock').val();
                    sectionActive.css(
                        'border-top-right-radius',
                        topRightBlock + 'px'
                    );

                    break;

                case 'set-rdBTLeftBlock':
                    var BTLeftBlock = $('#set-rdBTLeftBlock').val();
                    sectionActive.css(
                        'border-bottom-left-radius',
                        BTLeftBlock + 'px'
                    );

                    break;

                case 'set-rdBTRightBlock':
                    var BTRightBlock = $('#set-rdBTRightBlock').val();
                    sectionActive.css(
                        'border-bottom-right-radius',
                        BTRightBlock + 'px'
                    );

                    break;

                case 'set-allRDBlock':
                    var BTAllBlock = $('#set-allRDBlock').val();
                    $('.range-slider-all-Block').slider('value', BTAllBlock);
                    $('.Input-slide-BoxRadiusAll-Block')
                        .val(BTAllBlock)
                        .keyup();

                    break;
            }
        });

        $('.Input-slide-Padding').bind('keyup mouseup', function () {
            var sectionActive = $('.mgActive').get(0)
                ? $('.mgActive').parent()
                : $('#frameBody').get(0).contentWindow.$('.mgActive').parent();

            var isRang = $(this).parent().prev().find('.ui-slider');
            var isValue = $(this).val();

            isRang.slider('value', isValue);

            var Activemargin = $(this).attr('id');

            if ($(this).hasClass('Input-slide-Block')) {
                sectionActive = RVwys.getBlockBG;
                switch (Activemargin) {
                    case 'set-pdLeftBlock':
                        var PDLeft = $('#set-pdLeftBlock').val();
                        sectionActive.css('padding-left', PDLeft + '%');
                        break;

                    case 'set-pdRightBlock':
                        var PDRight = $('#set-pdRightBlock').val();
                        sectionActive.css('padding-right', PDRight + '%');
                        break;

                    case 'set-pdTopBlock':
                        var PDTop = $('#set-pdTopBlock').val();
                        sectionActive.css('padding-top', PDTop + '%');
                        break;

                    case 'set-pdBottomBlock':
                        var PDBottom = $('#set-pdBottomBlock').val();
                        sectionActive.css('padding-bottom', PDBottom + '%');
                        break;
                }
            } else {
                switch (Activemargin) {
                    case 'set-pdLeftSection':
                        var PDLeft = $('#set-pdLeftSection').val();
                        sectionActive.css('padding-left', PDLeft + '%');
                        break;

                    case 'set-pdRightSection':
                        var PDRight = $('#set-pdRightSection').val();
                        sectionActive.css('padding-right', PDRight + '%');
                        break;

                    case 'set-pdTopSection':
                        var PDTop = $('#set-pdTopSection').val();
                        sectionActive.css('padding-top', PDTop + '%');
                        break;

                    case 'set-pdBottomSection':
                        var PDBottom = $('#set-pdBottomSection').val();
                        sectionActive.css('padding-bottom', PDBottom + '%');
                        break;
                }
            }
        });

        $('.shadowColor').spectrum({
            showAlpha: true,
            showInput: true,
            allowEmpty: true,
            preferredFormat: 'rgb',
            change: function (color) {
                var sectionActive = $('.mgActive').get(0)
                    ? $('.mgActive').parent()
                    : $('#frameBody')
                          .get(0)
                          .contentWindow.$('.mgActive')
                          .parent();
                if ($(this).hasClass('Block-shadowColor')) {
                    sectionActive = RVwys.getBlockBG;
                }

                if (color) {
                    $(this).attr('cmd-shadow', color.toRgbString());
                    sectionActive.attr('cmd-shadow', color.toRgbString());
                } else {
                    $(this).attr('cmd-shadow', '');
                    sectionActive.attr('cmd-shadow', '');
                }

                if ($(this).hasClass('Block-shadowColor')) {
                    RVwys.setBlockShadow(sectionActive);
                } else {
                    RVwys.setSectionShadow(sectionActive);
                }
            },

            move: function (color) {
                var sectionActive = $('.mgActive').get(0)
                    ? $('.mgActive').parent()
                    : $('#frameBody')
                          .get(0)
                          .contentWindow.$('.mgActive')
                          .parent();

                if ($(this).hasClass('Block-shadowColor')) {
                    sectionActive = RVwys.getBlockBG;
                }

                if (color) {
                    sectionActive.attr('cmd-shadow', color.toRgbString());
                } else {
                    sectionActive.attr('cmd-shadow', '');
                }

                if ($(this).hasClass('Block-shadowColor')) {
                    RVwys.setBlockShadow(sectionActive);
                } else {
                    RVwys.setSectionShadow(sectionActive);
                }
            },
        });

        // $('#section-slider-MarginBottom')
        $('.preset-shadow').click(function () {
            var sectionActive = $('.mgActive').get(0)
                ? $('.mgActive').parent()
                : $('#frameBody').get(0).contentWindow.$('.mgActive').parent();

            var cssShadow = $(this).attr('cmd-shadow');
            var ColorShadow = 'rgba(0, 0, 0, 0.3)';

            if ($('#set-shadowProperties').attr('cmd-shadow')) {
                ColorShadow = $('#set-shadowProperties').attr('cmd-shadow');
            }

            if ($(this).hasClass('preset-shadow-Block')) {
                sectionActive = RVwys.getBlockBG;

                if ($('#set-shadowBlockProperties').attr('cmd-shadow')) {
                    ColorShadow = $('#set-shadowBlockProperties').attr(
                        'cmd-shadow'
                    );
                }
            }

            sectionActive.attr('cmd-shadow', ColorShadow);
            sectionActive.css('box-shadow', cssShadow + ' ' + ColorShadow);

            if ($(this).hasClass('preset-shadow-Block')) {
                RVwys.setCurrentShadowBlock(sectionActive);
            } else {
                RVwys.setCurrentShadowSection(sectionActive);
            }
        });

        $('.preset-overlap').click(function () {
            var mgTop = $(this).attr('mg-top');
            var mgLeft = $(this).attr('mg-left');
            var mgRight = $(this).attr('mg-right');
            var mgBottom = $(this).attr('mg-bottom');

            var sectionActive = $('.mgActive').get(0)
                ? $('.mgActive').parent()
                : $('#frameBody').get(0).contentWindow.$('.mgActive').parent();

            if ($(this).hasClass('preset-overlap-Block')) {
                sectionActive = RVwys.getBlockBG.parent();
            }

            sectionActive.css({
                'margin-top': mgTop,
                'margin-left': mgLeft,
                'margin-right': mgRight,
                'margin-bottom': mgBottom,
            });

            if ($(this).hasClass('preset-overlap-Block')) {
                RVwys.setCurrentOverlapBlock(sectionActive);
            } else {
                RVwys.setCurrentOverlapSection(sectionActive);
            }
        });

        //   Border Section
        $('.BorderSizePT').bind('mouseup keyup', function (e) {
            var sectionActive = $('.mgActive').get(0)
                ? $('.mgActive').parent()
                : $('#frameBody').get(0).contentWindow.$('.mgActive').parent();

            if ($(this).hasClass('BorderSizeBlock')) {
                sectionActive = RVwys.getBlockBG;
            }
            var mn = $(this).val().match('^\\d+$');

            if (mn && mn != 0) {
                sectionActive
                    .attr('border', $(this).val())
                    .css({ 'border-width': $(this).val() + 'px' });
            } else {
                $(this).val('');
                sectionActive
                    .attr('border', $(this).val())
                    .css({ 'border-width': $(this).val() + 'px' });
                $(this).find('dt a span').html('None');
            }
            $(this).focus();
        });

        $('.BorderStylePT dt a').click(function () {
            if ($(this).get(0).id == 'rvselectbox2') {
                $(this).closest('.BorderStylePT').find('dd ul').toggle();
            }
        });

        $('.BorderStylePT dd ul li a').click(function () {
            var sectionActive = $('.mgActive').get(0)
                ? $('.mgActive').parent()
                : $('#frameBody').get(0).contentWindow.$('.mgActive').parent();

            if ($(this).closest('.BorderStyleBlock').get(0)) {
                sectionActive = RVwys.getBlockBG;
            }

            var text = $(this).find('span').eq(0).html();

            $(this).closest('.BorderStylePT').find('dt a span').html(text);
            $(this).closest('.BorderStylePT').find('dd ul').hide();

            sectionActive.css('border-style', $(this).attr('set'));
        });

        $('.BorderColorBox').spectrum({
            showInput: true,
            allowEmpty: true,
            preferredFormat: 'hex',
            beforeShow: function () {
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    'background-color': 'red',
                    opacity: '0.0',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $('body').width(),
                    height: $('body').height(),
                });
                parent.$('body').prepend(overlaypanel);
                parent.$(document).bind('click.spectrum', function () {
                    $('#set-blockProperties').spectrum('revert');
                });
            },
            move: function (color) {
                var sectionActive = $('.mgActive').get(0)
                    ? $('.mgActive').parent()
                    : $('#frameBody')
                          .get(0)
                          .contentWindow.$('.mgActive')
                          .parent();

                if ($(this).hasClass('BorderColorBlock')) {
                    sectionActive = RVwys.getBlockBG;
                }

                RVwys.setBorderColor(sectionActive, color);
            },

            hide: function (color) {
                var sectionActive = $('.mgActive').get(0)
                    ? $('.mgActive').parent()
                    : $('#frameBody')
                          .get(0)
                          .contentWindow.$('.mgActive')
                          .parent();

                if ($(this).hasClass('BorderColorBlock')) {
                    sectionActive = RVwys.getBlockBG;
                }

                RVwys.setBorderColor(sectionActive, color);
                parent.$('.overlaypanel').remove();
                parent.$(document).unbind('click.spectrum');
            },
        });

        $('.gdColor').spectrum({
            showAlpha: true,
            showInput: true,
            allowEmpty: true,
            preferredFormat: 'rgb',
            beforeShow: function () {
                var overlaypanel = $('<div class="overlaypanel"></div>').css({
                    'background-color': 'red',
                    opacity: '0.0',
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    width: $('body').width(),
                    height: $('body').height(),
                });
                parent.$('body').prepend(overlaypanel);
                parent.$(document).bind('click.spectrum', function () {
                    $(this).spectrum('revert');
                });
            },
            move: function (color) {
                color = color.toRgbString();
                var isBlock = $(this).is('[cmd-this="block"]');
                $(this).attr('gdcolor', color);

                RVwys.ChangeGradient(isBlock);
            },

            hide: function (color) {
                parent.$('.overlaypanel').remove();
                parent.$(document).unbind('click.spectrum');
            },
        });
    });

    $(document).bind('designReady', function (e) {});

    RVwys.setSectionShadow = function (sectionActive) {
        var xOffset = $('#set-HTSection').val();
        var yOffset = $('#set-VTSection').val();
        var blur = $('#set-BlurSection').val();
        var spread = $('#set-SpreadSection').val();
        var colorRGB = sectionActive.attr('cmd-shadow');

        if (!colorRGB) {
            colorRGB = 'rgba(0, 0, 0, 0.3)';
            parent.$('#set-shadowProperties').spectrum('set', colorRGB);
        }

        // sectionActive.attr('style',{'box-shadow':''+ xOffset +'px '+yOffset+'px '+ blur +'px '+ spread +'px #000'});
        sectionActive.css({
            'box-shadow':
                xOffset +
                'px ' +
                yOffset +
                'px ' +
                blur +
                'px ' +
                spread +
                'px ' +
                colorRGB,
        });
    };

    RVwys.setBlockShadow = function (sectionActive) {
        var xOffset = $('#set-HTBlock').val();
        var yOffset = $('#set-VTBlock').val();
        var blur = $('#set-BlurBlock').val();
        var spread = $('#set-SpreadBlock').val();
        var colorRGB = sectionActive.attr('cmd-shadow');

        if (!colorRGB) {
            colorRGB = 'rgba(0, 0, 0, 0.3)';
            parent.$('#set-shadowBlockProperties').spectrum('set', colorRGB);
        }

        // sectionActive.attr('style',{'box-shadow':''+ xOffset +'px '+yOffset+'px '+ blur +'px '+ spread +'px #000'});
        sectionActive.css({
            'box-shadow':
                xOffset +
                'px ' +
                yOffset +
                'px ' +
                blur +
                'px ' +
                spread +
                'px ' +
                colorRGB,
        });
    };

    RVwys.setBorderColor = function (sectionActive, color) {
        if (color == null) {
            sectionActive.css('border-color', '');
        } else {
            sectionActive.css('border-color', color);
        }
    };

    RVwys.setCurrentShadowSection = function (sectionActive) {
        if (sectionActive.css('box-shadow') != 'none') {
            var cssShadow = sectionActive.css('box-shadow');
            var cssShadowMatch = cssShadow.match(/(-?[0-9]+)px/g);
            var cssShadowColor = sectionActive.attr('cmd-shadow');
            var shadowSet = { Xoffset: '', Yoffset: '', Blur: '', Spread: '' };

            var indexKey = 0;
            $.each(shadowSet, function (indexInArray) {
                shadowSet[indexInArray] = cssShadowMatch[indexKey].match(
                    /(-?[0-9]+)/
                )[0];
                indexKey++;
            });

            /* console.log(shadowSet['Xoffset']);
			console.log(shadowSet['Yoffset']);
			console.log(shadowSet['Blur']);
			console.log(shadowSet['Spread']); */

            parent.$('#set-shadowProperties').spectrum('set', cssShadowColor);

            parent.$('#set-HTSection').val(shadowSet['Xoffset']);
            parent
                .$('#section-slider-HT')
                .slider('option', 'value', shadowSet['Xoffset']);

            parent.$('#set-VTSection').val(shadowSet['Yoffset']);
            parent
                .$('#section-slider-VT')
                .slider('option', 'value', shadowSet['Yoffset']);

            parent.$('#set-BlurSection').val(shadowSet['Blur']);
            parent
                .$('#section-slider-Blur')
                .slider('option', 'value', shadowSet['Blur']);

            parent.$('#set-SpreadSection').val(shadowSet['Spread']);
            parent
                .$('#section-slider-Spread')
                .slider('option', 'value', shadowSet['Spread']);
        } else {
            parent.$('#set-shadowProperties').spectrum('set', '');

            parent.$('#set-HTSection').val('0');
            parent.$('#section-slider-HT').slider('option', 'value', '0');

            parent.$('#set-VTSection').val('0');
            parent.$('#section-slider-VT').slider('option', 'value', '0');

            parent.$('#set-BlurSection').val('0');
            parent.$('#section-slider-Blur').slider('option', 'value', '0');

            parent.$('#set-SpreadSection').val('0');
            parent.$('#section-slider-Spread').slider('option', 'value', '0');
        }
    };

    RVwys.setCurrentOverlapSection = function (sectionActive) {
        var elemGetCss = sectionActive.get(0).style;

        var mgLeft = elemGetCss.marginLeft.match(/\%/)
            ? elemGetCss.marginLeft.replace('%', '')
            : '0';
        var mgRight = elemGetCss.marginRight.match(/\%/)
            ? elemGetCss.marginRight.replace('%', '')
            : '0';
        var mgTop = elemGetCss.marginTop.match(/\%/)
            ? elemGetCss.marginTop.replace('%', '')
            : '0';
        var mgBottom = elemGetCss.marginBottom.match(/\%/)
            ? elemGetCss.marginBottom.replace('%', '')
            : '0';

        parent
            .$('#section-slider-MarginLeft')
            .slider('option', 'value', mgLeft);
        parent.$('#set-mgLeftSection').val(mgLeft);

        parent
            .$('#section-slider-MarginRight')
            .slider('option', 'value', mgRight);
        parent.$('#set-mgRightSection').val(mgRight);

        parent.$('#section-slider-MarginTop').slider('option', 'value', mgTop);
        parent.$('#set-mgTopSection').val(mgTop);

        parent
            .$('#section-slider-MarginBottom')
            .slider('option', 'value', mgBottom);
        parent.$('#set-mgBottomSection').val(mgBottom);
    };

    RVwys.setCurrentBoxSection = function (sectionActive) {
        /* console.log('topLeft ->'+topLeft);
		console.log('topRight ->'+topRight); */

        var topLeft = ReplacePX(sectionActive.css('border-top-left-radius'));
        var topRight = ReplacePX(sectionActive.css('border-top-right-radius'));
        var BTLeft = ReplacePX(sectionActive.css('border-bottom-right-radius'));
        var BTRight = ReplacePX(sectionActive.css('border-bottom-left-radius'));

        // topLeft+'px '+topRight+'px '+BTLeft+'px '+BTRight+'px'
        parent.$('#section-slider-rdTopleft').slider('value', topLeft);
        parent.$('#set-rdLeftSection').val(topLeft);

        parent.$('#section-slider-rdTopRight').slider('value', topRight);
        parent.$('#set-rdRightSection').val(topRight);

        parent.$('#section-slider-rdBTleft').slider('value', BTLeft);
        parent.$('#set-rdBTLeftSection').val(BTLeft);

        parent.$('#section-slider-rdBTRight').slider('value', BTRight);
        parent.$('#set-rdBTRightSection').val(BTRight);

        if ((topLeft == topRight) == (BTLeft == BTRight)) {
            parent.$('#section-slider-rdAll').slider('value', topLeft);
            parent.$('#set-allRDSection').val(topLeft);
        } else {
            parent.$('#section-slider-rdAll').slider('value', '0');
            parent.$('#set-allRDSection').val('0');
        }

        /****** Border Style Section*****/

        // Border Size
        var bdSize = ReplacePX(sectionActive.get(0).style.borderWidth);
        if (bdSize) {
            parent.$('#BorderSizeSection').val(bdSize);
        } else {
            parent.$('#BorderSizeSection').val('');
            sectionActive.removeAttr('border');
        }

        // Border Align
        var bdStyle = sectionActive.get(0).style.borderStyle;
        if (bdStyle) {
            parent.$('.BorderStyleSection dt a span').html(bdStyle);
        } else {
            parent.$('.BorderStyleSection dt a span').html('None');
        }

        // Border Color
        var bdColor = sectionActive.get(0).style.borderColor;

        if (bdColor) {
            parent.$('.BorderColorSection').spectrum('set', bdColor);
        } else {
            parent.$('.BorderColorSection').spectrum('set', '');
        }

        /* Padding Section */
        var pdLeft = ReplacePercen(sectionActive.get(0).style.paddingLeft);
        var pdRight = ReplacePercen(sectionActive.get(0).style.paddingRight);
        var pdTop = ReplacePercen(sectionActive.get(0).style.paddingTop);
        var pdBottom = ReplacePercen(sectionActive.get(0).style.paddingBottom);

        parent.$('#section-slider-pdLeft').slider('value', pdLeft);
        parent.$('#set-pdLeftSection').val(pdLeft);

        parent.$('#section-slider-pdRight').slider('value', pdRight);
        parent.$('#set-pdRightSection').val(pdRight);

        parent.$('#section-slider-pdTop').slider('value', pdTop);
        parent.$('#set-pdTopSection').val(pdTop);

        parent.$('#section-slider-pdBottom').slider('value', pdBottom);
        parent.$('#set-pdBottomSection').val(pdBottom);
    };

    function ReplacePX(data) {
        return data.replace('px', '');
    }

    function ReplacePercen(data) {
        if (data) {
            data = data.replace('%', '');
        } else {
            data = 0;
        }
        return data;
    }

    RVwys.setCurrentShadowBlock = function (sectionActive) {
        if (sectionActive.css('box-shadow') != 'none') {
            var cssShadow = sectionActive.css('box-shadow');
            var cssShadowMatch = cssShadow.match(/(-?[0-9]+)px/g);
            var cssShadowColor = sectionActive.attr('cmd-shadow');
            var shadowSet = { Xoffset: '', Yoffset: '', Blur: '', Spread: '' };

            var indexKey = 0;
            $.each(shadowSet, function (indexInArray) {
                shadowSet[indexInArray] = cssShadowMatch[indexKey].match(
                    /(-?[0-9]+)/
                )[0];
                indexKey++;
            });

            parent
                .$('#set-shadowBlockProperties')
                .spectrum('set', cssShadowColor);

            parent.$('#set-HTBlock').val(shadowSet['Xoffset']);
            parent
                .$('#block-slider-HT')
                .slider('option', 'value', shadowSet['Xoffset']);

            parent.$('#set-VTBlock').val(shadowSet['Yoffset']);
            parent
                .$('#block-slider-VT')
                .slider('option', 'value', shadowSet['Yoffset']);

            parent.$('#set-BlurBlock').val(shadowSet['Blur']);
            parent
                .$('#block-slider-Blur')
                .slider('option', 'value', shadowSet['Blur']);

            parent.$('#set-SpreadBlock').val(shadowSet['Spread']);
            parent
                .$('#block-slider-Spread')
                .slider('option', 'value', shadowSet['Spread']);
        } else {
            parent.$('#set-shadowBlockProperties').spectrum('set', '');

            parent.$('#set-HTBlock').val('0');
            parent.$('#block-slider-HT').slider('option', 'value', '0');

            parent.$('#set-VTBlock').val('0');
            parent.$('#block-slider-VT').slider('option', 'value', '0');

            parent.$('#set-BlurBlock').val('0');
            parent.$('#block-slider-Blur').slider('option', 'value', '0');

            parent.$('#set-SpreadBlock').val('0');
            parent.$('#block-slider-Spread').slider('option', 'value', '0');
        }
    };

    RVwys.setCurrentOverlapBlock = function (sectionActive) {
        var elemGetCss = sectionActive.get(0).style;

        var mgLeft = elemGetCss.marginLeft.match(/\%/)
            ? elemGetCss.marginLeft.replace('%', '')
            : '0';
        var mgRight = elemGetCss.marginRight.match(/\%/)
            ? elemGetCss.marginRight.replace('%', '')
            : '0';
        var mgTop = elemGetCss.marginTop.match(/\%/)
            ? elemGetCss.marginTop.replace('%', '')
            : '0';
        var mgBottom = elemGetCss.marginBottom.match(/\%/)
            ? elemGetCss.marginBottom.replace('%', '')
            : '0';

        parent.$('#block-slider-MarginLeft').slider('option', 'value', mgLeft);
        parent.$('#set-mgLeftBlock').val(mgLeft);

        parent
            .$('#block-slider-MarginRight')
            .slider('option', 'value', mgRight);
        parent.$('#set-mgRightBlock').val(mgRight);

        parent.$('#block-slider-MarginTop').slider('option', 'value', mgTop);
        parent.$('#set-mgTopBlock').val(mgTop);

        parent
            .$('#block-slider-MarginBottom')
            .slider('option', 'value', mgBottom);
        parent.$('#set-mgBottomBlock').val(mgBottom);
    };

    RVwys.setCurrentBoxBlock = function (BlockActive) {
        var topLeft = ReplacePX(BlockActive.css('border-top-left-radius'));
        var topRight = ReplacePX(BlockActive.css('border-top-right-radius'));
        var BTLeft = ReplacePX(BlockActive.css('border-bottom-left-radius'));
        var BTRight = ReplacePX(BlockActive.css('border-bottom-right-radius'));

        // topLeft+'px '+topRight+'px '+BTLeft+'px '+BTRight+'px'
        parent.$('#block-slider-rdTopleft').slider('value', topLeft);
        parent.$('#set-rdLeftBlock').val(topLeft);

        parent.$('#block-slider-rdTopRight').slider('value', topRight);
        parent.$('#set-rdRightBlock').val(topRight);

        parent.$('#block-slider-rdBTleft').slider('value', BTLeft);
        parent.$('#set-rdBTLeftBlock').val(BTLeft);

        parent.$('#block-slider-rdBTRight').slider('value', BTRight);
        parent.$('#set-rdBTRightBlock').val(BTRight);

        if ((topLeft == topRight) == (BTLeft == BTRight)) {
            parent.$('#block-slider-rdAll').slider('value', topLeft);
            parent.$('#set-allRDBlock').val(topLeft);
        } else {
            parent.$('#block-slider-rdAll').slider('value', '0');
            parent.$('#set-allRDBlock').val('0');
        }

        /****** Border Style block*****/

        // Border Size
        var bdSize = ReplacePX(BlockActive.get(0).style.borderWidth);
        if (bdSize) {
            parent.$('#BorderSizeBlock').val(bdSize);
        } else {
            parent.$('#BorderSizeBlock').val('');
            BlockActive.removeAttr('border');
        }

        // Border Align
        var bdStyle = BlockActive.get(0).style.borderStyle;
        if (bdStyle) {
            parent.$('.BorderStyleBlock dt a span').html(bdStyle);
        } else {
            parent.$('.BorderStyleBlock dt a span').html('None');
        }

        // Border Color
        var bdColor = BlockActive.get(0).style.borderColor;

        if (bdColor) {
            parent.$('.BorderColorBlock').spectrum('set', bdColor);
        } else {
            parent.$('.BorderColorBlock').spectrum('set', '');
        }

        /* Padding block */
        var pdLeft = ReplacePercen(BlockActive.get(0).style.paddingLeft);
        var pdRight = ReplacePercen(BlockActive.get(0).style.paddingRight);
        var pdTop = ReplacePercen(BlockActive.get(0).style.paddingTop);
        var pdBottom = ReplacePercen(BlockActive.get(0).style.paddingBottom);

        parent.$('#block-slider-pdLeft').slider('value', pdLeft);
        parent.$('#set-pdLeftBlock').val(pdLeft);

        parent.$('#block-slider-pdRight').slider('value', pdRight);
        parent.$('#set-pdRightBlock').val(pdRight);

        parent.$('#block-slider-pdTop').slider('value', pdTop);
        parent.$('#set-pdTopBlock').val(pdTop);

        parent.$('#block-slider-pdBottom').slider('value', pdBottom);
        parent.$('#set-pdBottomBlock').val(pdBottom);
    };

    RVwys.CurrentSection = function (isElem) {
        var ElemTab = parent.$(
            '.wys-rowFour .mode-tabs>ul li[aria-controls!="mode-background"][aria-controls!="mode-shadow"]'
        );

        if (isElem.closest('#selected_footer').get(0)) {
            ElemTab.hide();
            parent.$('.wys-rowFour .mode-tabs').tabs('option', 'active', 0);
        } else {
            if (ElemTab.is(':hidden')) {
                ElemTab.show();
            }
        }
    };

    RVwys.SetCurrentGradient = function (gdColor, isThis) {
        var bgLeft = '';
        var bgRight = '';

        if (gdColor.match(/linear-gradient/)) {
            var regexRadian = /\(([0-9a-zA-Z\s]+)/;
            var regexPattenColor = /((rgba|rgb)\(([0-9\,\.\s]+)\))/gm;

            bgLeft = gdColor.match(regexPattenColor)[0];
            bgRight = gdColor.match(regexPattenColor)[1];
        }

        if (isThis) {
            var gdLeftSection = $('#gdLeftSection').get(0)
                ? $('#gdLeftSection')
                : parent.$('#gdLeftSection');
            var gdRightSection = $('#gdRightSection').get(0)
                ? $('#gdRightSection')
                : parent.$('#gdRightSection');

            gdLeftSection.spectrum('set', bgLeft);
            gdLeftSection.attr('gdColor', bgLeft);

            gdRightSection.spectrum('set', bgRight);
            gdRightSection.attr('gdColor', bgRight);
        } else {
            var gdLeftBlock = $('#gdLeftBlock').get(0)
                ? $('#gdLeftBlock')
                : parent.$('#gdLeftBlock');
            var gdRightBlock = $('#gdRightBlock').get(0)
                ? $('#gdRightBlock')
                : parent.$('#gdRightBlock');

            gdLeftBlock.spectrum('set', bgLeft);
            gdLeftBlock.attr('gdColor', bgLeft);

            gdRightBlock.spectrum('set', bgRight);
            gdRightBlock.attr('gdColor', bgRight);
        }
    };

    RVwys.ChangeGradient = function (isBlock) {
        var elm =
            RVwys.getRowBG ||
            RVwys.getParentByClass(
                $(RVwys.targetAnimatObj),
                'rvsb_design_block'
            );

        var colorLeft = $('#gdLeftSection').attr('gdColor');
        var colorRight = $('#gdRightSection').attr('gdColor');

        if (isBlock) {
            elm = RVwys.getBlockBG;
            colorLeft = $('#gdLeftBlock').attr('gdColor');
            colorRight = $('#gdRightBlock').attr('gdColor');
        }

        var ColorGradient =
            'linear-gradient(90deg, ' +
            colorLeft +
            ' 0%, ' +
            colorRight +
            ' 100%)';
        elm.get(0).style.background = ColorGradient;
    };

    RVwys.designViewAddEvent('mouseup', function (e) {
        //	 rowProperties

        // RVwys.setCurrentRowBG(e.target);
        // RVwys.setCurrentBGIMAGE(e.target);
        // RVwys.setCurrentParallaxCustomSection(e.target);

        // //  parent.RVwys.getBlockBG = RVwys.getParentByClass(($(e.target),'rvsb_design_block'));
        // //  console.log(parent.RVwys.getBlockBG);
        // parent.RVwys.getrowProperties = RVwys.getParentByClass($(e.target),'rvsb_design_block').parent();

        //  RVwys.setCurrentShadowSection(parent.RVwys.getrowProperties);
        //  RVwys.setCurrentOverlapSection(parent.RVwys.getrowProperties);
        //  RVwys.setCurrentBoxSection(parent.RVwys.getrowProperties);
        parent.rowParallaxSlide = false;

        //	BlockProperties
        parent.$('.propColor').spectrum('enable');
        // parent.RVwys.getBlockBG = RVwys.getParentByClass($(e.target),'RVWYSIWYGAREA');
        parent.RVwys.getBlockBG = $(e.target).closest('.RVWYSIWYGAREA');

        RVwys.setCurrentBlockBGIMAGE(parent.RVwys.getBlockBG);
        RVwys.setCurrentBlockBG(parent.RVwys.getBlockBG);
        RVwys.setCurrentParallaxCustomBlock(parent.RVwys.getBlockBG);
        RVwys.setCurrentShadowBlock(parent.RVwys.getBlockBG);
        RVwys.setCurrentOverlapBlock(parent.RVwys.getBlockBG.parent());
        RVwys.setCurrentBoxBlock(parent.RVwys.getBlockBG);

        //	 Animation
        parent.RVwys.targetAnimatObj = $(RVwys.currentiFrame);
        RVwys.setDefaultAnimation($(RVwys.currentiFrame));
    });

    RVwys.designViewAddEvent('keyup', function (e) {});
})(jQuery);
